import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useDeleteDocument = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ documentId }: { documentId: number }) => {
			return await EndpointsService.dataRetriever.deleteDocument({
				documentId,
			});
		},
		onSuccess: (_data) => {
			// Invalidate and refetch documents data
			queryClient.invalidateQueries({ queryKey: ["documents"] });
		},
	});
};
